import React, { useState, useEffect } from 'react';
import { useSettings } from '../contexts/SettingsContext';
import { FaClock, FaExclamationTriangle } from 'react-icons/fa';

const CountdownTimer = ({ showWarning = true, lightTheme = false }) => {
  const { getTimeUntilDeadline, isOrderingCurrentlyOpen } = useSettings();
  const [timeLeft, setTimeLeft] = useState(getTimeUntilDeadline());

  useEffect(() => {
    const timer = setInterval(() => {
      const newTimeLeft = getTimeUntilDeadline();
      setTimeLeft(newTimeLeft);
    }, 1000);

    return () => clearInterval(timer);
  }, [getTimeUntilDeadline]);

  const formatNumber = (num) => num.toString().padStart(2, '0');

  const isUrgent = timeLeft.hours <= 2 && timeLeft.hours > 0;
  const isCritical = timeLeft.hours === 0 && timeLeft.minutes <= 30;
  const isExpired = timeLeft.total <= 0;

  if (isExpired) {
    return (
      <div className="text-center">
        <div className="d-flex align-items-center justify-content-center gap-2 mb-2">
          <FaExclamationTriangle className={lightTheme ? "text-white" : "text-danger"} />
          <span className={`fw-bold ${lightTheme ? "text-white" : "text-danger"}`}>Ordering Closed</span>
        </div>
        <p className={lightTheme ? "text-white mb-0" : "text-secondary mb-0"}>Next ordering cycle will open soon</p>
      </div>
    );
  }

  return (
    <div className="text-center">
      <div className="d-flex align-items-center justify-content-center gap-2 mb-2">
        <FaClock className={lightTheme ? 'text-white' : (isCritical ? 'text-danger' : isUrgent ? 'text-warning' : 'text-primary')} />
        <span className={`fw-bold ${lightTheme ? 'text-white' : (isCritical ? 'text-danger' : isUrgent ? 'text-warning' : 'text-primary')}`}>
          Order Deadline
        </span>
      </div>
      
      <div className="countdown-timer mb-2">
        <div className="d-flex justify-content-center gap-2">
          <div className="countdown-unit">
            <div className={`countdown-number ${lightTheme ? 'bg-white text-primary' : (isCritical ? 'bg-danger' : isUrgent ? 'bg-warning' : 'bg-primary')}`}>
              {formatNumber(timeLeft.hours)}
            </div>
            <div className={`countdown-label ${lightTheme ? 'text-white' : ''}`}>Hours</div>
          </div>
          <div className={`countdown-separator ${lightTheme ? 'text-white' : ''}`}>:</div>
          <div className="countdown-unit">
            <div className={`countdown-number ${lightTheme ? 'bg-white text-primary' : (isCritical ? 'bg-danger' : isUrgent ? 'bg-warning' : 'bg-primary')}`}>
              {formatNumber(timeLeft.minutes)}
            </div>
            <div className={`countdown-label ${lightTheme ? 'text-white' : ''}`}>Minutes</div>
          </div>
          <div className={`countdown-separator ${lightTheme ? 'text-white' : ''}`}>:</div>
          <div className="countdown-unit">
            <div className={`countdown-number ${lightTheme ? 'bg-white text-primary' : (isCritical ? 'bg-danger' : isUrgent ? 'bg-warning' : 'bg-primary')}`}>
              {formatNumber(timeLeft.seconds)}
            </div>
            <div className={`countdown-label ${lightTheme ? 'text-white' : ''}`}>Seconds</div>
          </div>
        </div>
      </div>
      
      {showWarning && (isUrgent || isCritical) && (
        <div className={`alert ${isCritical ? 'alert-danger' : 'alert-warning'} py-2 px-3 mb-0`}>
          <small>
            <FaExclamationTriangle className="me-1" />
            {isCritical 
              ? 'Ordering closes soon! Place your order now.'
              : 'Ordering deadline approaching!'
            }
          </small>
        </div>
      )}
    </div>
  );
};

export default CountdownTimer; 